<template>
  <span>
    <v-btn
      color="white"
      :class="{
        'bg-nitro' : true ,
        'bg-transparent border-white' : $store.state.module.view_dark,
      }"
      outlined
      fab
      small
      @click="showMenuMobile = !showMenuMobile"
    >
      <v-icon>fas fa-bars</v-icon>
    </v-btn>
    <v-bottom-sheet v-model="showMenuMobile">
      <v-sheet
        height="100%"
      >
        <ModuleContentMenu @close="showMenuMobile=false" />
      </v-sheet>
    </v-bottom-sheet>
  </span>
</template>
<script>
import { mapGetters } from 'vuex';
import ModuleContentMenu from './ModuleContentMenu.vue';

export default {
    components: { ModuleContentMenu },
    computed:{
        ...mapGetters(['show_module_menu_mobile']),
        showMenuMobile:{
            get(){
                return this.$store.state.module.show_module_menu_mobile
            },
            set(value){
                this.$store.state.module.show_module_menu_mobile = value
            }
        }
    }
}
</script>